export default __webpack_public_path__ + "static/media/expobg.97ec8216.png";